import ApiService from '../apiService';

export default {
  /*
    Error message types:
    DS_BRIDGE_NO_CURRENT_STEP
    DS_TRANSFORMER_NO_STEP
    DS_TRANSFORMER_NO_TRANSFORMER_ID
    DS_TRANSFORMER_NO_TRANSFORMER
    DS_TRANSFORMER_INVALID_INPUT
    DS_TRANSFORMER_INVALID_OUTPUT
    DS_TRANSFORMER_EXEC_ERROR
    DS_FILTER_NO_STEP
    DS_FILTER_NO_FILTER_ID
    DS_FILTER_NO_FILTER
    DS_FILTER_INVALID_INPUT
    DS_FILTER_INVALID_FILTER_TYPE
    DS_FILTER_EXEC_ERROR
    DS_FILTER_NOT_BOOLEAN
  */

  // **********************************************************
  //
  // CONSUMERS
  //
  // **********************************************************
  consumersFetch(tenantIds) {
    return ApiService.instance.get(`/consumer/list?tenantIds=[${tenantIds}]`).then((response) => {
      return response.data;
    });
  },
  consumersCreate(tenantId, data) {
    return ApiService.instance.post('/consumer/', { tenantId, ...data }).then((response) => {
      return response.data;
    });
  },
  consumersUpdate(id, data) {
    return ApiService.instance.put(`/consumer/${id}`, { id, ...data }).then((response) => {
      return response.data;
    });
  },
  consumersDelete(id) {
    return ApiService.instance.delete(`/consumer/${id}`).then((response) => {
      return response.data;
    });
  },
  // **********************************************************
  //
  // TRANSFORMERS
  //
  // **********************************************************
  consumerTransformersFetch(tenantIds) {
    return ApiService.instance.get(`/consumer/transformer/list?tenantIds=[${tenantIds}]`).then((response) => {
      return response.data;
    });
  },
  consumerTransformersGet(transformerId) {
    return ApiService.instance.get(`/consumer/transformer/${transformerId}`).then((response) => {
      return response.data;
    });
  },
  consumerTransformersCreate(tenantId, data) {
    return ApiService.instance.post('/consumer/transformer/', { tenantId, ...data }).then((response) => {
      return response.data;
    });
  },
  consumerTransformersUpdate(id, data) {
    return ApiService.instance.put(`/consumer/transformer/${id}`, { id, ...data }).then((response) => {
      return response.data;
    });
  },
  consumerTransformersDelete(id) {
    return ApiService.instance.delete(`/consumer/transformer/${id}`).then((response) => {
      return response.data;
    });
  },
  consumerTransformersTest(data) {
    return ApiService.instance.post('/consumer/transformer/test/', data).then((response) => {
      return response.data;
    });
  },
  // **********************************************************
  //
  // FILTERS
  //
  // **********************************************************
  consumerFiltersFetch(tenantIds) {
    return ApiService.instance.get(`/consumer/filter/list?tenantIds=[${tenantIds}]`).then((response) => {
      return response.data;
    });
  },
  consumerFiltersCreate(tenantId, data) {
    return ApiService.instance.post('/consumer/filter/', { tenantId, ...data }).then((response) => {
      return response.data;
    });
  },
  consumerFiltersUpdate(id, data) {
    return ApiService.instance.put(`/consumer/filter/${id}`, { id, ...data }).then((response) => {
      return response.data;
    });
  },
  consumerFiltersDelete(id) {
    return ApiService.instance.delete(`/consumer/filter/${id}`).then((response) => {
      return response.data;
    });
  },
};
